import ViewRecommendedItems from 'src/pages/ViewRecommendedItems';
import { useContextSelector } from 'use-context-selector';
import ShoppingListProductListView from './ShoppingListProductListView';
import ShoppingListProductPictureView from './ShoppingListProductPictureView';
import { ShoppingListProductsContext } from './ShoppingListProductsContext';

const ToggleShoppingListProductView = () => {
  const listId = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.listId
  );
  const selectedView = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.selectedView
  );
  const isSwapItemModalOpen = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.isSwapItemModalOpen
  );
  const handleCloseSwapItemPanel = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.handleCloseSwapItemPanel
  );
  const swapItemData = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.swapItemData
  );

  return (
    <>
      <div
        className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden"
        style={{ gridArea: 'main' }}
      >
        {selectedView === 0 ? (
          <ShoppingListProductListView key={listId} />
        ) : (
          <ShoppingListProductPictureView key={listId} />
        )}
      </div>
      <ViewRecommendedItems
        isOpenSidePanel={isSwapItemModalOpen}
        onCloseSidePanel={() => handleCloseSwapItemPanel()}
        isInternal={true}
        dataParams={isSwapItemModalOpen ? swapItemData : null}
      />
    </>
  );
};

export default ToggleShoppingListProductView;
